module.exports = __webpack_public_path__ + "img/logo.20e1c6ba.png";